import React from 'react';
import Assistant from './components/Assistant';
import './App.css';

function App() {
  return (
    <div className="app">
      <h1></h1>
      <Assistant />
    </div>
  );
}

export default App;